import React, { useContext } from 'react'

import { MenuContext } from 'contexts/Menu'
import { GeneralContext } from 'contexts/General'
import withCustomCursor from 'hoc/withCustomCursor'

import MenuFooter from '@/Menus/MenuFooter'
import Grid from '@/UI/Grid'
import Container from '@/UI/Container'
import Text from '@/UI/Text'
import CustomImage from '@/UI/Image'
import RichText from '@/UI/RichText'
import Newsletter from '@/Newsletter'

import {
  StyledFooter,
  StyledFooterRow,
  StyledFooterCol,
  StyledFooterLower,
  StyledFooterIcons,
} from './styles'

import { FooterIcons } from 'fixtures/footer'

const Footer = (props) => {
  const { menus } = useContext(MenuContext)
  const { page } = useContext(GeneralContext)
  const { footer } = menus

  const hideFooter = !!page.removeFooter

  if (hideFooter || !footer) return <></>

  const footerUpperColumns = !!footer.upper ? footer.upper.reduce((acc, el) => {
    const colNumber = el.columns && el.columns !== 0 ? el.columns : 1
    return acc + colNumber
  }, 0) : 0

  return (
    <StyledFooter
      className='Footer'
      data-theme='inverted'
      {...props}>
      <Container>
        {
          footer.payoff &&
            <StyledFooterRow css={{
              borderTop: 'none',
              display: 'inline-flex',
              alignItems: 'flex-end',
              flexWrap: 'wrap',
              gap: '2rem',
              justifyContent: 'flex-start',
              width: '100%',
              '@md': {
                justifyContent: 'space-between',
                gap: '4rem',
              },
            }}>
              <RichText
                size={{
                  '@initial': 'h2-mobile',
                  '@md': 'h2'
                }}
                content={footer.payoff}
              />
              <StyledFooterIcons>

                {
                  FooterIcons.map((icon) => (
                    <CustomImage
                      key={icon.attributes.name}
                      data={icon}
                      objectFit="contain"
                      css={{
                        maxHeight: '32px',
                        width: '100%',
                        height: '100%',
                        '@md': { maxHeight: '72px', }
                      }}
                    />
                  ))
                }
              </StyledFooterIcons>
            </StyledFooterRow>
        }
        <StyledFooterRow>
          <Newsletter />
        </StyledFooterRow>

        {
          footer.upper &&
          <StyledFooterRow>
            <Grid
              gapX={3}
              flow="row"
              columns={{
                '@initial': 1,
                '@md': footerUpperColumns
              }}
            >
              {
                footer.upper.map((el, idx) => <MenuFooter key={idx} {...el} />)
              }
            </Grid>
          </StyledFooterRow>
        }

        {
          footer.lower &&
          <StyledFooterRow>
            <StyledFooterLower>
              <StyledFooterCol css={{ 'grid-area': 'company' }}>
                <Text size="footer" css={{ color: '$white' }}>
                @ {new Date().getFullYear()} {footer.company}
                </Text>
              </StyledFooterCol>
              <StyledFooterCol css={{ 'grid-area': 'menus' }}>
                <Grid
                  flow="row"
                  gapX={3}
                  css={{
                    '@md': {
                      placeItems: 'center',
                      alignItems: 'center'
                    }
                  }}
                  columns={{
                    '@initial': 1,
                    '@md': 2
                  }}
                >
                  {
                    footer.lower.map((el, idx) => <MenuFooter key={idx} {...el} />)
                  }
                </Grid>

              </StyledFooterCol>
              <StyledFooterCol css={{
                textAlign: 'right',
                gridArea: 'iva',
              }}>
                <Text size="footer" css={{ color: '$white' }} >
                  {footer.vatNumber}
                </Text>
              </StyledFooterCol>
            </StyledFooterLower>
          </StyledFooterRow>
        }

      </Container>
    </StyledFooter>
  )
}

export default withCustomCursor(Footer)
